import React from "react"
import "./banner.css"
// import business_page_banner_gradient_background from '../images/banner-gradient-background-1.png';

export class BusinesspageBannerContent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    const html = (
      <>
        <div className="banner-content">
          <div
            className="banner-content-background"
            style={{
              backgroundImage: `url(/banner-gradient-background-1.png)`,
            }}
          ></div>
          <div className="banner-title homepage-banner-title business-banner-title">
            Expand your reach. Inspire a generation.
            <br />
            Place your business in classrooms
            <br />
            across the nation.
          </div>
        </div>
      </>
    )
    return html
  }
}
